module.exports = __webpack_public_path__ + "static/Operate circle-0f4a4ebad83e84746ecdbc8b8dd0cc93.png";